import React, { useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { AuthProvider, useAuth } from "./components/context/AuthContext";
import SidebarComponent from "../src/components/sidebar/SidebarComponet";
import Login from "../src/components/login/LoginPage";
import { HMSRoomProvider } from "@100mslive/react-sdk";
import ResetPassword from "./components/resetPassword/ResetPassword";
import SignUp from "./components/signUp/SignUp";
import NotFound from "./components/NotFound";

const PrivateRoute = ({ children, isNotFound }) => {
  const { user } = useAuth();
  const authToken = sessionStorage.getItem("authToken");

  if (!user || !authToken) {
    return <Navigate to="/login" />;
  }

  if (isNotFound) {
    return <NotFound />;
  }

  return children;
};

const App = () => {
  const [isNotFound, setIsNotFound] = useState(false);

  const handleNotFound = () => {
    setIsNotFound(true);
  };

  return (
    <AuthProvider>
      <Router basename={process.env.PUBLIC_URL}>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/signup" element={<SignUp />} />
          <Route
            path="*"
            element={
              <PrivateRoute isNotFound={isNotFound}>
                <SidebarComponent handleNotFound={handleNotFound} />
              </PrivateRoute>
            }
          />
        </Routes>
      </Router>
    </AuthProvider>
  );
};

export default App;
